import { render, staticRenderFns } from "./Listing.vue?vue&type=template&id=673dd0c0&scoped=true"
import script from "./Listing.vue?vue&type=script&lang=js"
export * from "./Listing.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Listing.vue?vue&type=style&index=0&id=673dd0c0&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "673dd0c0",
  null
  ,true
)

export default component.exports